import { render, staticRenderFns } from "./TheNavigation.vue?vue&type=template&id=087f0e42"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"
import style0 from "./TheNavigation.vue?vue&type=style&index=0&id=087f0e42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports